import React from 'react';
import { Translations } from '../i18n/translations';

interface FooterProps {
  t: Translations;
}

export const Footer: React.FC<FooterProps> = ({ t }) => {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-white dark:bg-gray-800 border-t-4 border-black dark:border-gray-600 mt-8 mb-14 sm:mb-20">
      <div className="px-4 sm:px-6 py-4 sm:py-6">
        <p className="text-sm text-gray-600 dark:text-gray-400 text-center">
          {t.copyright.replace('{year}', year.toString())}
        </p>
      </div>
    </footer>
  );
};
